/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Conheça novas pessoas, converse, divirta-se",
      "Número de telefone incorreto",
      "Baixar o aplicativo",
      "Continuar com Apple",
      "Continuar com Facebook",
      "Continuar com Google",
      "Entrar",
      "Registrar-se",
      "Para continuar, por favor digite os caracteres que você vê na caixa abaixo.",
      "Continuar",
      "Digite os caracteres",
      "Verificação de segurança",
      "Atualizar",
      "Crie uma nova senha que seja fácil de lembrar:",
      "Atualizar",
      "Confirme a senha",
      "A senha deve conter pelo menos {{num}} [[characters:num]]",
      "Senha",
      "Criar nova senha",
      "Blog do Badoo",
      "Vagas",
      "Conversas",
      "Cidades",
      "Gerenciar cookies",
      "Copyright © 2006 – presente. Bumble. Todos os direitos reservados.",
      "Apple e o logotipo da Apple são marcas comerciais da Apple Inc.{{__EOL__}}Google Play é uma marca registrada da Google LLC.",
      "Baixe o app",
      "Facebook",
      "Siga-nos",
      "Central de Ajuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Informações Gerais",
      "O Badoo faz parte da Bumble Inc.",
      "Política de privacidade",
      "Safety Centre",
      "Mapa do site",
      "Declaração da Lei Modern Slavery Act",
      "Termos e condições",
      "Twitter",
      "Insira seu e-mail ou número de celular e enviaremos as instruções para criar uma nova senha.",
      "Obter nova senha",
      "Insira seu e-mail ou número de telefone",
      "Esqueci minha senha",
      "Modelos usados apenas para fins ilustrativos",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Não precisa esperar por uma conexão.{{__EOL__}}{{__EOL__}}Pule direto para as coisas boas. Você sabe, aquela parte em que vocês conversam para realmente se conhecerem.",
      "A fim de conversar agora?",
      "Ao se registrar, você concorda com nossos <a class=\"link\" href=\"{{terms_url}}\">Termos & Condições</a>. Saiba como usamos seus dados em nossa <a class=\"link\" href=\"{{privacy_url}}\">Política de Privacidade</a>",
      "Ajudamos você a mostrar seu verdadeiro eu, <br />para criar conexões com confiança.",
      "Encontros com total confiança.",
      "Ou",
      "Já tem uma conta?",
      "Registre-se com seu email ou número de telefone",
      "Diga o que você procura.{{__EOL__}}Sem rodeios.",
      "Quer apenas conversar? Tudo bem.{{__EOL__}}Quer algo sério? Perfeito.{{__EOL__}}{{__EOL__}}E se mudar de ideias, estamos aqui também.",
      "Encontros casuais",
      "Um relacionamento",
      "Conversar",
      "Encontre pessoas que querem o mesmo que você.",
      "{{name}}, {{age}}",
      "Sua segurança é nossa prioridade máxima.",
      "O nosso Safety Centre é a nossa área de informações, para encontrar todo o suporte que você precisa para ter encontros com confiança.",
      "Visite o nosso Safety Centre",
      "Segurança<br/>em primeiro lugar sempre.",
      "Desde o início eu sabia que ia dar certo entre a gente...",
      "Quando entrei, eu não estava procurando algo sério...",
      "Um conselho para quem está no app do Badoo é: seja você mesmo...",
      "Histórias de Sucesso do Badoo",
      "Descubra mais histórias de sucesso",
      "{{num}}__CUT__Pontuação",
      "Apple App Store",
      "Confie em nós! Já facilitamos mais de um bilhão de conexões desde 2006.",
      "+ de {{num}}M__CUT__de downloads",
      "+ de {{num}}M",
      "Google Play Store",
      "Sabemos o que estamos fazendo.",
      "Entre com seu e-mail ou número de telefone",
      "Insira sua senha",
      "Esqueceu sua senha?",
      "Cadastrar-se",
      "Ainda não tem uma conta?",
      "Entrar",
      "Cadastrar-se"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "caracteres"
            ],
            "singular": [
                  "caracter"
            ]
      },
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
